import React from 'react';
import { LineViewTabsContext } from '../Lineup/context/LineViewTabsContext';
import { LineTabs } from '../Lineup/ui/LineTabs';
import { LineupStatsSandbox } from '../Lineup/ui/LineupStats';

const LineupSandbox: React.FC = () => {
  return <div>
    <LineupStatsSandbox />
  </div>
};

export default LineupSandbox;
